<div class="loading-overlay"
    [ngClass]="{show: showLoader, transparent: loaderOptions.transparent}">
    <div class="loader"></div>
</div>